"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOpeningHash = exports.toJSONString = exports.getUserTokenAMP = exports.getTimezoneOffset = exports.getFormattedClientTimeStamp = void 0;
var user_1 = require("./user");
function leftPad(len, z) {
    var original = typeof z === "string" ? z : z.toString();
    var s = '';
    len = (len || 2) - original.length;
    while (s.length < len)
        s += "0";
    return s + original;
}
exports.getFormattedClientTimeStamp = function () {
    var tmpDate = new Date();
    return tmpDate.getFullYear() + "-" + leftPad(2, tmpDate.getMonth() + 1) + "-" + leftPad(2, tmpDate.getDate()) + " " + leftPad(2, tmpDate.getHours()) + ":" + leftPad(2, tmpDate.getMinutes()) + ":" + leftPad(2, tmpDate.getSeconds()) + "." + tmpDate.getMilliseconds();
};
exports.getTimezoneOffset = function () { return (new Date().getTimezoneOffset() * (-60)); };
exports.getUserTokenAMP = function () { return 'CLIENT_ID(usu_tiendeo)'; };
exports.toJSONString = function (value) { return (value || '').replace(/\"/g, '\\\"'); };
exports.generateOpeningHash = function () {
    var tmpDate = new Date();
    var openingHash = tmpDate.getFullYear() + '-' + (tmpDate.getMonth() + 1) + '-' + tmpDate.getDate() + ' ' + tmpDate.getHours() + ':' + tmpDate.getMinutes() + ':' + tmpDate.getSeconds() + '.' + tmpDate.getMilliseconds();
    return openingHash;
};
function getStatsCommonProperties(getCookie, setCookie) {
    var authUser = user_1.getAuthUser(getCookie);
    var SessionId = getCookie("sessionId");
    return {
        UserToken: user_1.getStatsUser(getCookie, setCookie),
        UserId: authUser ? authUser.id : '',
        ClientTimeStamp: exports.getFormattedClientTimeStamp(),
        TimeZoneOffset: exports.getTimezoneOffset(),
        SessionId: SessionId
    };
}
exports.default = getStatsCommonProperties;
//# sourceMappingURL=commonProperties.js.map